import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, addDoc, updateDoc, deleteField } from "firebase/firestore";
import { auth, db, storage, messaging } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import Divider from '@mui/material/Divider';


const linkList = [

  { label: 'Send Link', value: 'yes' },

  { label: `Dn't Send`, value: 'no' },

];


const New = () => {



  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [title, setTitle] = useState("")

  const [description, setDescription] = useState("")

  const [brandname, setBrandname] = useState("")

  const [brandaddress, setBrandaddress] = useState("")

  const [brandtelephone, setBrandTelephone]= useState("")

  const [brandsocials, setBrandsocials] = useState("")
  
  const [ perc, setPerc ] = useState(null)
  
  const [file, setFile ] = useState("")

  const [advertImage, setAdvertImage] = useState("")

  const [viewCount, SetViewCount] = useState(0)

  const [sendLink, setSendLink ] = useState("yes")

  const [likeCount, setLikeCount] = useState(0)

  const [messageCount, setMessageCount] = useState(0)

  const [brandstatus, setBrandstatus] = useState('active')

  const [advertId, setAdvertId] = useState("")

  const [errorTitle, setErrorTitle] = useState(false)

  const [errorDescription, setErrorDescription] = useState(false)

  const [errorBrandname, setErrorBrandname] = useState(false)

  const [errorBrandaddress, setErrorBrandaddress] = useState(false)

  const [errorBrandtelephone, setErrorBrandtelephone] = useState(false)

  const [errorBrandsocials, setErrorBrandsocials] = useState(false)
  
  const [errorSendLink, setErrorSendLink] = useState(false)

  const [errorfile, setErrorFile] = useState(false)

  const navigate = useNavigate();



  
    useEffect(() => {

      // setIsloading(true)

      const uploadFile = () => {
  
        const name = new Date().getTime() + file.name;
        
        const storageRef = ref(storage, "advertImages/"+name);
  
        const uploadTask = uploadBytesResumable(storageRef, file);
  
        uploadTask.on('state_changed', 
          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            setPerc('Upload is ' + progress.toFixed(0) + '% complete')
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              // set((prev) => ({...prev, img: downloadURL}))
              setAdvertImage(downloadURL)

              // setIsloading(false)

            });
          }
        );
  
      };
  
      file && uploadFile();
  
  }, [file]);




  const deleteUrl = () => {

        const deleteRef = ref(storage, advertImage);
    
            // Delete the file
        deleteObject(deleteRef)

        setAdvertImage("")

        setFile("")
        
        // .then(async() => {
    
    
        //     const adRef = doc(db, 'adverts', advertId);
    
        //     // Remove the 'capital' field from the document
        //     await updateDoc(adRef, {

        //         advertImage: deleteField()

        //     });

        //     setAdvertImage("")

        //     setFile("")
    
    
        // }).catch((error) => {
        //     // Uh-oh, an error occurred!
        //     console.log(error)
        // });
    
  }

  
    
    const handleAdverts = async(e) => {
  
      e.preventDefault()

      if(title === ""){
        
        return setErrorTitle("Title is required")
      }

       if(description === ""){
        
        return setErrorDescription("Description is required")
      }

       if(brandname === ""){
        
        return setErrorBrandname("Brand name is required")
      }

       if(brandaddress === ""){
        
        return setErrorBrandaddress("Brand Address is required")
      }

       if(brandtelephone === ""){
        
        return setErrorBrandtelephone("Brand Telephone is required")
      }

        if(sendLink === ""){
        
        return setErrorSendLink("Link State is required")
      }

       if(file === ""){
        
        return setErrorFile("Brand Photo is required")
      }

      


      setIsloading(true)
  
      try{
           
         const advertResponse = await addDoc(collection(db, "adverts"), {
        
          title: title,
          description: description,
          viewCount: viewCount,
          likeCount: likeCount,
          messageCount: messageCount,
          datePublished: today,
          advertImage: advertImage,
          sendLink : sendLink,
          brandname: brandname,
          brandaddress: brandaddress,
          brandtelephone: brandtelephone,
          brandsocials: brandsocials,
          status : brandstatus,
          timeStamp: serverTimestamp(),
          
        });

        const advert = advertResponse.id

        setAdvertId(advert)
        
        setIsloading(false)

        navigate("/adverts")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handleTitle = (e) => {

         setTitle(e.target.value)

         if(title !== ""){

          setErrorTitle(false)
          
         }

    }


    const handleDescription = (e) => {

         setDescription(e.target.value)

         if(description !== ""){

          setErrorDescription(false)
          
         }

    }

    const handleBrandname = (e) => {

         setBrandname(e.target.value)

         if(brandname !== ""){

          setErrorBrandname(false)
          
         }

    }

      const handleBrandaddress = (e) => {

         setBrandaddress(e.target.value)

         if(brandname !== ""){

          setErrorBrandaddress(false)
          
         }

    }


    const handleBrandTelephone = (e) => {

         setBrandTelephone(e.target.value)

         if(brandtelephone !== ""){

          setErrorBrandtelephone(false)
          
         }

    }


     const handleBrandSocials = (e) => {

         setBrandsocials(e.target.value)

         if(brandsocials !== ""){

          setErrorBrandsocials(false)
          
         }

    }


     const handleChangeLink = (e) => {

         setSendLink(e.target.value)

         if(sendLink !== ""){

          setErrorSendLink(false)
          
         }

    }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Advert</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/adverts"
            >
              Advert List
            </Link>
            <Typography color="green">New Advert</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'column', width: '100%', gap:20}}>
                
                  <TextField
                    type="text"
                    name="title"
                    placeholder="Enter Advert Title"
                    value={title}
                    onChange={handleTitle}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />
                  {
                    errorTitle &&

                    <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

                  }
                  <TextField
                    type="text"
                    name="Description"
                    placeholder="Enter Advert Description"
                    value={description}
                    multiline
                    minRows={3}
                    maxRows={10}
                    onChange={handleDescription}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />

                   {
                    errorDescription &&

                    <p style={{color:'red', fontSize:15, }}>{errorDescription}</p>

                  }

                  <TextField
                    type="text"
                    name="brandname"
                    placeholder="Enter Brand Name"
                    value={brandname}
                    onChange={handleBrandname}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />

                   {
                    errorBrandname &&

                    <p style={{color:'red', fontSize:15, }}>{errorBrandname}</p>

                  }

                  <TextField
                    type="text"
                    name="brandaddress"
                    placeholder="Enter Brand Address"
                    value={brandaddress}
                    onChange={handleBrandaddress}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />

                   {
                    errorBrandaddress &&

                    <p style={{color:'red', fontSize:15, }}>{errorBrandaddress}</p>

                  }

                  <TextField
                    type="text"
                    name="brandtelephone"
                    placeholder="Enter Telephone"
                    value={brandtelephone}
                    onChange={handleBrandTelephone}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />

                   {
                    errorBrandtelephone &&

                    <p style={{color:'red', fontSize:15, }}>{errorBrandtelephone}</p>

                  }

                    <TextField
                    type="text"
                    name="brandsocails"
                    placeholder="Enter Brand Social Media or Website"
                    value={brandsocials}
                    onChange={handleBrandSocials}
                    style={{width:'100%', backgroundColor:'#f9e3ff'}}
                  />

                 {
                    errorBrandsocials &&

                    <p style={{color:'red', fontSize:15, }}>{errorBrandsocials}</p>

                  }


                  <Box sx={{ minWidth: '100%' , backgroundColor:"#f9e3ff" }} >
                    <FormControl fullWidth>
                    <InputLabel id="sendLink" style={{color:'#999', fontWeight:300}}>Send Link</InputLabel>
                    <Select
                      labelId="sendLink"
                      id="sendLink"
                      value={sendLink}
                      // key={resetKeyArea}
                      label="Send Link"
                      onChange={handleChangeLink}
                      // onChange={change}
                    
                    >

                      {linkList.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            {item.value}
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>

                  {errorSendLink &&
                  <p style={{color:'red', fontSize:15, marginVertical:5}}> {errorSendLink}</p>
                  }
                  
            
                
                </div>


                <hr style={{width:'100%', height:1, color:'$eee'}}/>


                   <div style={{display:'flex', width:'100%'}}>

                    {

                     ( file && !advertImage)
                       
                    &&

                      <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
                      }}>

                      <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

                      </div>

                    }

                    {

                      (advertImage && file)
                      
                      &&

                      <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10}}>


                        <img
                        src={URL.createObjectURL(file) }
                        alt=""
                        // className='imgs'
                        style={{width:'100%', height:'80%', cursor:'pointer'}}
                        resizeMode = "contain"
                      />

                      <Button onClick={deleteUrl} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

                      </div>

                      }


                      {

                        (!advertImage && !file)

                        &&


                       <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
                        <label htmlFor='file'>
                        {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
                        <img
                        src="../images/cloud.png"
                        alt=""
                        style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
                        // className='imgs'
                        resizeMode = "contain"
                      />

                       <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload Advert Image</p>
                        </label>
                       
                         <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p>
                        <input type="file" id="file" onChange= {e => setFile(e.target.files[0])} style={{display:'none'}}/>
                      </div>



                      }

                      
                  </div>

                  {
                    errorfile &&

                    <p style={{color:'red', fontSize:15, }}>{errorfile}</p>

                  }


                <hr style={{width:'100%', height:1, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handleAdverts} 
                    disabled={perc !== null && perc < 100}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...Loading Advert' : 'Submit Advert'}
                    
                  </Button>


               


          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New
